const getPriceSearchParam = (priceSearchQuery) => { var _a; return ((_a = priceSearchQuery === null || priceSearchQuery === void 0 ? void 0 : priceSearchQuery.map(price => price * 100)) === null || _a === void 0 ? void 0 : _a.join(',')) || undefined; };
export default getPriceSearchParam;
